<template>
  <div>
    <b-modal
      id="detail-employee-paid-leave-modal"
      size="lg"
      :title="title"
      no-close-on-backdrop
    >
      <table class="table table-bordered table-sm table-striped">
        <tbody>
          <tr>
            <th class="font-weight-bold">Nama Karyawan</th>
            <td>{{ result.employee ? result.employee.fullName : '-' }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Kuota Cuti</th>
            <td>{{ result.paidLeaveLeft }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Jenis</th>
            <td>{{ result.paidLeave ? result.paidLeave.category.paramListDesc : '-' }}</td>
          </tr>
        </tbody>
      </table>

    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";


export default {
  components: {
    BCol,
    BAvatar,
    BRow,
  },
  props: ["pageTitle", "result"],
  data() {
    return {
      title: `Detail ${this.pageTitle}`,
    };
  },
};
</script>
